import { Component, inject, Signal } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { AvatarModule } from 'primeng/avatar';
import { ToolbarModule } from 'primeng/toolbar';
import { CardModule } from 'primeng/card';
import { CommonModule } from '@angular/common';
import { Observable, take } from 'rxjs';
import { Store } from '@ngxs/store';
import { environment } from '@tsin-env/environment';
import { Router, RouterModule } from '@angular/router';
import { AuthState } from '@tsin-core/store/auth/auth.state';
import { AuthResponse, UserAuthResponse } from '@tsin-core/store/auth/auth.model';
import { AuthActions } from '@tsin-core/store/auth/auth.actions';

@Component({
  selector: 'app-main-header',
  standalone: true,
  imports: [
    CommonModule,
    AvatarModule,
    ButtonModule,
    RouterModule,
    ToolbarModule,
    CardModule,
  ],
  templateUrl: './main-header.component.html',
  styleUrl: './main-header.component.scss',
})
export class MainHeaderComponent {
  store: Store = inject(Store);
  router: Router = inject(Router);
  auth$: Observable<AuthResponse> = this.store
    .select(AuthState.getAuth)
    .pipe(take(1));
  loading$: Observable<boolean> = this.store.select(AuthState.isLoading);
  email: Signal<string> = this.store.selectSignal<string>(AuthState.getEmail);

  user: Signal<UserAuthResponse> = this.store.selectSignal<UserAuthResponse>(AuthState.getUser);


  logout() {
    // write logout logic
    this.store.dispatch([new AuthActions.Logout()]);
    window.location.href = '/';
    return;
  }
}
